<template>
  <div class="ui-sort-tag-wrapper">
    <span class="sort-num">{{ orderNum }}</span>
    <span>号</span>
  </div>
</template>

<script>
export default {
  name: "uiSortDefault",
  props: {
    orderNum: {
      type: [String, Number],
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-sort-tag-wrapper {
  background: rgba(0, 0, 0, 0.6);
  border-radius: 1.6rem 2rem 2rem 0;
  height: 0.36rem;
  padding: 0 0.08rem;
  line-height: 0.36rem;
  font-family: PingFang-SC-Bold;
  font-size: 0.22rem;
  color: #ffffff;
  position: absolute;
  top: -0.11rem;
  left: -0.1rem;
  .sort-num {
    font-family: PingFangSC-Regular;
    font-weight: bold;
    color: #ffdc67;
    font-size: 0.24rem;
    letter-spacing: 0.004rem;
  }
}
</style>
